interface DateSeparatorProps {
  date: Date;
}

export function DateSeparator({ date }: DateSeparatorProps) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  
  const messageDate = new Date(date);
  messageDate.setHours(0, 0, 0, 0);
  
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  
  let label: string;
  
  if (messageDate.getTime() === today.getTime()) {
    label = 'Today';
  } else if (messageDate.getTime() === yesterday.getTime()) {
    label = 'Yesterday';
  } else {
    // Format as "Month Day, Year" for older dates
    label = messageDate.toLocaleDateString('en-US', { 
      month: 'long', 
      day: 'numeric',
      year: messageDate.getFullYear() !== today.getFullYear() ? 'numeric' : undefined
    });
  }
  
  return (
    <div className="flex items-center justify-center my-6">
      <div className="flex items-center gap-3 w-full max-w-md">
        <div className="flex-1 h-px bg-slate-200"></div>
        <span className="text-xs font-medium text-slate-500 px-3 py-1 bg-white rounded-full">
          {label}
        </span>
        <div className="flex-1 h-px bg-slate-200"></div>
      </div>
    </div>
  );
}

